require('./brokerCallMeBackView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { capitalize } = require('lodash');
const { withRouter } = require('react-router-dom');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { ContentBox } = require('commonsComponents/contentBox');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @ components
const {
    BrokerInvestmentSpecialist
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const { ModalUsPersonBlock } = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');
const AppDownloadWidget = require('components/appDownloadWidget/appDownloadWidget');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ constants
const { MYPROFILE_BROKER_URL, BROKER_PG_URL } = require('constants/index');
const { WEALTH_BRING_VALUES_TO_OK_NEW_LANDING } = require('constants/flagBasedFeatures');

// @assets
import numberOne from 'assets/images/number_one_blue.svg';
import numberTwo from 'assets/images/number_two_blue.svg';

class BrokerCallMeBackView extends React.Component {
    buildBreadcrumb(fromSection) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText(`breadcrumb-brokerCallMeBack${fromSection}`)
            }
        ];
    }

    buildOldVersionContent() {
        const fromSection = capitalize(this.props.match.params.section);
        const supportTextKey = `broker-callMeBack${fromSection}SupportText`;
        const goToMyWalletButton = (
            <OKButton to={MYPROFILE_BROKER_URL}>
                <FormattedText value="broker-callMeBackGoToMyInvestments" />
            </OKButton>
        );
        return (
            <ContentBox customClassName="broker-call-me-back-view__notification-box">
                <EmptyState
                    primaryText={formatText(supportTextKey)}
                    button={goToMyWalletButton}
                    iconType="nointernet-wealth" />
            </ContentBox>
        )
    }

    buildNewVersionContent() {
        const customData = {
          nombrePagina: '/broker/bringStocks',
          sectionFamily: 'wealth',
          sectionCategory: 'products',
          sectionName: 'stocks',
          interactionType: 'screen',
          serviceType: 'productInformation',
        };
        window && window.utag && window.utag.view && window.utag.view(customData);

        return (
            <OKSectionBox
                title={"¿Quieres traer tus acciones a Openbank?"}
            >
                <div className={'broker-call-me-back-view__container'}>
                    <FormattedText value="broker-callMeBackDescriptionOne" />

                    <div className='broker-call-me-back-view__description-box'>
                        <div className='broker-call-me-back-view__description-box-item'>
                            <img src={numberOne} alt="Number one" />
                            <div className="broker-call-me-back-view__description-box-text">
                                <FormattedText value="broker-callMeBackDescriptionTwo" />
                            </div>
                        </div>
                        <div className='broker-call-me-back-view__description-box-item'>
                            <img src={numberTwo} alt="Number two" />
                            <div className="broker-call-me-back-view__description-box-text">
                                <FormattedText value="broker-callMeBackDescriptionThree" />
                            </div>
                        </div>
                    </div>
                    <FormattedText value="broker-callMeBackFooter" />
                </div>
            </OKSectionBox>
        )
    }

    render() {
        const { flagBasedFeatures } = this.props;
        const ffUsPersonTransferSecurities = flagBasedFeatures.get('wealth_transfer_securities_to_ok_us_person');
        const isNewLanding = flagBasedFeatures.get(WEALTH_BRING_VALUES_TO_OK_NEW_LANDING);
        const fromSection = capitalize(this.props.match.params.section);
        const titleKey = `broker-callMeBack${fromSection}Title`;
        const breadcrumb = this.buildBreadcrumb(fromSection);
        const description = isNewLanding ? this.buildNewVersionContent() : this.buildOldVersionContent();

        const content = (
            <div className="broker-call-me-back-view">
                <OKCover size="medium">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle(titleKey)} />
                </OKCover>
                <div className="broker-call-me-back-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            {description}
                        </div>
                        <div className="col-xs-4">
                            <BrokerInvestmentSpecialist  />
                            {isNewLanding &&
                                <div className="broker-call-me-back-view__download-widget">
                                    <AppDownloadWidget />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )

        return (
            <ModalUsPersonBlock
                children={content}
                featureFlag={ffUsPersonTransferSecurities}
                titleKey={'us_person_popup-transfer_securities_to_ok_title'}
                description={'us_person_popup-transfer_securities_to_ok_message'}
                buttonClick={() => this.props.history.push(BROKER_PG_URL)}
            />
        );
    }
}

BrokerCallMeBackView.propTypes = {
    match: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerCallMeBackView;
module.exports.BrokerCallMeBackView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
    }), {

}
)(withRouter(BrokerCallMeBackView));
